import { useTheme, Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper, Select, MenuItem, TextField } from "@mui/material";
import { StyledButton } from "../../components/StyledButton";
import { StyledBox } from "../../components/StyledBox";

export interface CredentialFormProps {
    credentialId : string,
    credentialType : string,
    isCredentialIdValid: boolean,
    handleChange: Function,
    handleSubmit: Function,
}

const CredentialForm: React.FC<CredentialFormProps> = ({credentialId, credentialType, isCredentialIdValid, handleChange, handleSubmit}) => {
    const theme = useTheme();

    return(
        <StyledBox >
            <TableContainer component={Paper} sx={{boxShadow: "none"}}>
                <Table sx={{border: `${theme.spacing(1/8)} solid ${theme.palette.common.black}`, borderCollapse: "separate"}} size="small">
                    <TableHead sx={{backgroundColor: theme.palette.primary.dark }}>
                        <TableRow>
                            <TableCell sx={{color: theme.palette.primary.contrastText }} colSpan={2}>
                                Validate a Credential
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        <TableRow sx={{height: 70}}>
                            <TableCell align="right" sx={{borderBottom: "none", width: "40%"}}>
                                Credential Type:
                            </TableCell>
                            <TableCell sx={{borderBottom: "none", width: "60%"}}>
                                <Select
                                    id="credentialType"
                                    size="small"
                                    value={credentialType}
                                    disabled
                                    sx={{
                                        height: 40,
                                        minWidth: 300,
                                        paddingTop: `${theme.spacing(1/2)}`,
                                        '& #credentialType': {
                                            fontSize: 16,
                                        }
                                    }}
                                >
                                    <MenuItem value="NCRC">ACT WorkKeys NCRC</MenuItem>
                                    <MenuItem value="SEL">SEL</MenuItem>
                                    <MenuItem value="WKES">WKES</MenuItem>
                                </Select>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="right" sx={{borderBottom: "none", width: "40%"}}>
                                Enter Credential ID:
                            </TableCell>
                            <TableCell sx={{borderBottom: "none", width: "60%"}}>
                                <TextField
                                    id="credentialId"
                                    value={credentialId}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {handleChange(event.target.value)}}
                                    sx={{
                                        height: 40,
                                        minWidth: 300,
                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: theme.palette.primary.dark
                                        }
                                    }}
                                    required
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={{width: "40%"}}>

                            </TableCell>
                            <TableCell sx={{width: "60%"}}>
                                <StyledButton type="submit" variant="contained" onClick={(event: React.MouseEvent<HTMLButtonElement>) => handleSubmit()} disabled={!isCredentialIdValid}>Validate</StyledButton>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </StyledBox>
    );
}

export default CredentialForm;